import { styled } from '@/styled-system/jsx';

// Main list container for highlights
export const HighlightsList = styled('ul', {
  base: {
    width: '100%',
    position: 'relative',
    margin: '0',
    padding: '0',
    listStyle: 'none',
  },
});

// Individual highlight list item
export const HighlightsListItem = styled('li', {
  base: {
    paddingBottom: '2x',
    paddingRight: '1x',
    minWidth: '0',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0', // No gap since icon has its own margin
  },
});

// Text component for highlight descriptions
export const HighlightsText = styled('span', {
  base: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'md',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1',
  },
});

// Icon component for highlight icons
export const HighlightsIcon = styled('img', {
  base: {
    float: 'left',
    width: '24px',
    height: '24px',
    textAlign: 'center',
    marginRight: '2x',
    flexShrink: '0',
  },
});
